import { render, staticRenderFns } from "./EmailSettings.vue?vue&type=template&id=111de742&scoped=true&"
import script from "./EmailSettings.vue?vue&type=script&lang=js&"
export * from "./EmailSettings.vue?vue&type=script&lang=js&"
import style0 from "./EmailSettings.vue?vue&type=style&index=0&id=111de742&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111de742",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cschwan/nextcloud/workspace/server/apps-extra/activity/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('111de742')) {
      api.createRecord('111de742', component.options)
    } else {
      api.reload('111de742', component.options)
    }
    module.hot.accept("./EmailSettings.vue?vue&type=template&id=111de742&scoped=true&", function () {
      api.rerender('111de742', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EmailSettings.vue"
export default component.exports